import { jwtDecode } from 'jwt-decode'
import { fetchBudgetManagementSystem } from '../redux/storeConfig/slices/slice.budgetManagement'

export const setSessionToken = sessionToken => async (dispatch, getState) => {
  try {
    if (!sessionToken) throw new Error('Session token is required')

    localStorage.setItem('authToken', sessionToken)
    const decodedTokenString = atob(sessionToken)
    const decodedToken = jwtDecode(decodedTokenString)
    // const decodedToken = JSON.parse(atob(decodedTokenString.split('.')[1]))

    dispatch({ type: 'CREATE_SESSION', payload: { rawToken: sessionToken, ...decodedToken } })
    // Refresh authenticated budget settings even when login keeps the same store view.
    // If no store view is loaded yet, its initialization will fetch them instead.
    const locationId = getState().storeViews.current?.id
    if (locationId) await dispatch(fetchBudgetManagementSystem(locationId))
  } catch (err) {
    console.error(err)
    dispatch({ type: 'CLEAR_SESSION', payload: '' })
  }
}

export const logOut = () => async dispatch => {
  dispatch({ type: 'CLEAR_SESSION', payload: '' })
}
